<template>
<div>
    <div class="md-layout rows-relatorio">
        <div v-if="permissoes.abastecimentosAnaliticoRead || permissoes.abastecimentosSinteticoRead" 
        class="md-layout-item md-size-100 md-xsmall-size-100">
            <strong class="text-relatorio text-site">FROTA</strong>
        </div>

        <div v-if="permissoes.abastecimentosAnaliticoRead" class="md-layout-item md-size-50 md-xsmall-size-100 btn-relatotio">
            <router-link class="md-site" :to="{name:'abastecimentosAnaliticoRead'}">
                <i class="fas fa-gas-pump icon-relatorio text-info"></i>
                <strong class="text-relatorio">ABASTECIMENTO ANALÍTICO</strong>
            </router-link>
        </div>

        <div v-if="permissoes.abastecimentosSinteticoRead" class="md-layout-item md-size-50 md-xsmall-size-100 btn-relatotio">
            <router-link class="md-simple" :to="{name:'abastecimentosSinteticoRead'}">
                <i class="fas fa-gas-pump icon-relatorio text-info"></i>
                <strong class="text-relatorio">ABASTECIMENTO SINTÉTICO</strong>
            </router-link>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            permissoes: this.$store.state.usuario.permissao
        }
    }
};
</script>
